import { CommonCMS } from "@lib/constants/contentful";

export enum Attributes {
    mainImage = "main",
    outsideImage = "outside",
    color = "Color",
    colorCode = "ColorCode",
    dominantColor = "DominantColor",
    backgroundColor = "BackgroundColor",
    productColors = "ProductColors",
    size = "Size",
    Gender = "Gender",
    articleNumber = "ArticleNumber",
    productNumber = "ProductNumber",
    descriptiveHeading = "DescriptiveHeading",
    DominantMaterial = "DominantMaterial",
    EAN = "EAN",
    EAN13 = "EAN13",
    Gtin13 = "Gtin13",
    Gtin = "Gtin",
    Barcode = "Barcode",
    fbStory = "FBStory",
    fbText1 = "FBText1",
    fbText2 = "FBText2",
    fbText3 = "FBText3",
    fbText4 = "FBText4",
    fbText5 = "FBText5",
    fbText6 = "FBText6",
    Division = "Division",
    collectionCategory = "CollectionCategory",
    collectionType = "CollectionType",
    collectionClass = "CollectionClass",
    CollectionSegment = "CollectionSegment",
    collectionCategoryCode = "CollectionCategoryCode",
    pageTitle = "PageTitle",
    countryOfOrigin = "CountryOfOrigin",
    howToUse = "HowToUse",
    MaterialGroup = "MaterialGroupLocalized",
    netQuantity = "NetQuantity",
    TargetGroup = "TargetGroup",
    sizeUS = "Size_US",
    sizeUK = "Size_UK",
    sizeCN = "Size_CN",
    sizeKR = "Size_KR",
    sizeJP = "Size_JP",
    sizeCA = "Size_CA",
    productNameCustomerFriendly = "ProductNameCustomerFriendly",
    ProductVideo = "ProductVideo",
    ProductCategory = "ProductCategory",
    ProductClass = "ProductClass",
    InteractiveVideo = "InteractiveVideo",
    CustomBadge1 = "CustomBadge1",
    CustomBadge2 = "CustomBadge2",
    CustomBadge3 = "CustomBadge3",
    CustomBadge1Scheduled = "CustomBadge1Scheduled",
    CustomBadge2Scheduled = "CustomBadge2Scheduled",
    CustomBadge3Scheduled = "CustomBadge3Scheduled",
    sizeSuggestion = "SizeSuggestion",
    VariantNumber = "VariantNumber",
    VariantGrossWeight = "VariantGrossWeight",
    VariantWeightUnit = "VariantWeightUnit",
    VariantDimensionOuterWidth = "VariantDimensionOuterWidth",
    VariantDimensionOuterHeight = "VariantDimensionOuterHeight",
    VariantDimensionOuterLength = "VariantDimensionOuterLength",
    VariantDimensionUnit = "VariantDimensionUnit",
    ProductMaterialIdentification = "ProductMaterialIdentification",
    MaterialIdentification = "MaterialIdentification",
    ProductSoleMaterial = "ProductSoleMaterial",
    SoleMaterial = "SoleMaterial",
    ProductSoleType = "ProductSoleType",
    SoleType = "SoleType",
    ProductLinningInners = "ProductLinningInners",
    ProductLiningInners = "ProductLiningInners",
    LiningInners = "LiningInners",
    LiningDescription = "LiningDescription",
    ProductLiningDescription = "ProductLiningDescription",
    ProductWaterTechnology = "ProductWaterTechnology",
    WaterTechnology = "WaterTechnology",
    ProductRemovableInsole = "ProductRemovableInsole",
    RemovableInsole = "RemovableInsole",
    ProductClosureType = "ProductClosureType",
    ClosureType = "ClosureType",
    ProductOccasion = "ProductOccasion",
    Occasion = "Occasion",
    ProductDivision = "ProductDivision",
    ProductTechnology = "ProductTechnology",
    Technology = "Technology",
    ProductHeelHeight = "ProductHeelHeight",
    HeelHeight = "HeelHeight",
    ProductSpikes = "ProductSpikes",
    Spikes = "Spikes",
    ProductCleatSystem = "ProductCleatSystem",
    CleatSystem = "CleatSystem",
    ProductExtraWidth = "ProductExtraWidth",
    ExtraWidth = "ExtraWidth",
    ProductExtraLaces = "ProductExtraLaces",
    ExtraLaces = "ExtraLaces",
    ProductUpperMaterialDescription = "ProductUpperMaterialDescription",
    UpperMaterialDescription = "UpperMaterialDescription",
    VariantSizeUS = "VariantSizeUS",
    VariantSizeUK = "VariantSizeUK",
}

export enum CustomAttributes {
    RECOMMENDED_PRICE = "price_CF_RecommendedRetailPrice",
    ADJUSTED_PRICE = "price_CF_AdjustedPrice",
    DISCOUNT_PERCENTAGE = "price_CF_DiscountPercentage",
    PREVIOUS_LOWEST_PRICE = "price_CF_PreviousLowestPrice",
    DISCOUNT_PERCENTAGE_PREVIOUS_LOWEST_PRICE = "price_CF_DiscountPercentagePreviousLowestPrice",
    LINE_ITEM_PRICE = "line-item_CF_Price",
    LINE_ITEM_DISCOUNTED_PRICE = "line-item_CF_DiscountedPrice",
    OFFER_IDS = "price_CF_OfferIds",
    PRICE_VALID_UNTIL = "price_CF_PriceValidUntil",
}

export const EXTRA_PRICE_CONFIG = {
    RecommendedPrice: {
        attribute: CustomAttributes.RECOMMENDED_PRICE,
        key: CommonCMS.price.recommendedPrice,
        setKey: CommonCMS.shared,
    },
    OmnibusPrice: {
        attribute: CustomAttributes.PREVIOUS_LOWEST_PRICE,
        key: CommonCMS.price.omnibusPrice,
        setKey: CommonCMS.shared,
    },
    AdjustedPrice: {
        attribute: CustomAttributes.ADJUSTED_PRICE,
        key: CommonCMS.price.adjustedPrice,
        setKey: CommonCMS.page,
    },
} as const;
